import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Bills from './Bills';
import Expenses from './Expenses';

const Finances = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('bills');

  const tabs = [
    { key: 'bills', label: 'Bills / Invoice', icon: 'fa-file-invoice-dollar' },
    { key: 'expenses', label: 'Expenses', icon: 'fa-receipt' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/staff')}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-white text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all shadow-md border border-gray-200"
              data-testid="back-to-admin-btn"
            >
              <i className="fas fa-arrow-left"></i>
              <span>Back to Admin</span>
            </button>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-emerald-600">Finances</p>
              <h1 className="text-2xl font-black text-slate-900 tracking-tight">Money in &amp; out</h1>
            </div>
          </div>
        </div>

        {/* Tab switcher */}
        <div className="inline-flex items-center bg-white rounded-2xl border border-slate-200 shadow-md p-1.5 mb-6" data-testid="finances-tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-5 py-2.5 rounded-xl font-bold text-sm transition-all ${
                tab === t.key
                  ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg'
                  : 'text-slate-500 hover:text-slate-800'
              }`}
              data-testid={`finances-tab-${t.key}`}
            >
              <i className={`fas ${t.icon} mr-2`}></i>
              {t.label}
            </button>
          ))}
        </div>

        {/* Active tab content */}
        {tab === 'bills' && <Bills embedded={true} />}
        {tab === 'expenses' && <Expenses embedded={true} />}
      </div>
    </div>
  );
};

export default Finances;
